import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">彩金分类导航</h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">按分类快速查找您感兴趣的注册送彩金内容，精准获取所需信息</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center text-center p-6 md:p-8 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-primary-100 rounded-xl mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-2xl text-primary-600 w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">{cat.name}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}